import React from "react";
import { Modal } from "antd";

const NoActiveLicenseDialog = ({ open }: {open: boolean}) => {
    return (
        <Modal
            title="No active License"
            open={open}
            closable={false}
            footer={null}
            width={500}
            data-testid="no-license-modal"
        >
            <div
                data-testid="no-license-message"
            >
                <strong>It seems that you have no active license.</strong>
                <br />
                <div
                >
                    <em>
                        If you need further information, please contact us at{" "}
                        <a href="mailto:support@healthiq.co.uk">
                            <strong>Vantage Support team</strong>
                        </a>
                    </em>
                </div>
            </div>
        </Modal>
    );
};

export default NoActiveLicenseDialog;
